var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column justify-content-center align-items-center",style:(_vm.iconStyle)},[_c('i',{staticClass:"far fa-chart-bar icon_table"}),_c('div',{staticClass:"text_table",domProps:{"textContent":_vm._s(_vm.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }